const firebaseConfig = {
  apiKey: "AIzaSyA48_q9gR4rC4nJPrD6E3gBZK-WwStJrA8",
  authDomain: "sleepvillage-dev.firebaseapp.com",
  projectId: "sleepvillage-dev",
  storageBucket: "sleepvillage-dev.appspot.com",
  messagingSenderId: "194986381562",
  appId: "1:194986381562:web:63e12675fadeb63a183943",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore(app);

const addDocument = async (data, collectionName = "swatches") => {
  try {
    await db.collection(collectionName).add(data);
  } catch (error) {
    alert("Data is stored successfully.");
  }
};

const getCollectionByName = async (collectionName = "swatches") => {
  const collectionData = [];
  try {
    const querySnapshot = await db.collection(collectionName).get();
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      data.id = doc.id;
      collectionData.push(data);
    });
    return collectionData;
  } catch (error) {
    throw error.message;
  }
};

const deleteDocument = async (collectionName = "swatches", id) => {
  try {
    await db.collection(collectionName).doc(id).delete();
  } catch (error) {
    console.log(error);
    throw "error in deleting data";
  }
};
